<template>
    <div id="modal" :style="{display:status}" class="modal" @click="closeSideBar">
        <div class="modal-content">
            <div class="sidePanel-header">
                <div class="sidePanel-header-icon">
                    <router-link :to="selfUrl">
                    <img :src="url"/>
                    </router-link>
                </div>
                <div class="sidePanel-header-username">
                    <router-link :to="selfUrl">
                    {{this.$store.state.userName}}
                    </router-link>
                </div>
            </div>
            <div class="sidePanel-menu">
                <router-link to="/home"><div class="sidePanel-menu-item smooth-trans">首页</div></router-link>
                <router-link to="/contact"><div class="sidePanel-menu-item smooth-trans">通讯录</div></router-link>
                <!-- <router-link to="/setting"><div class="sidePanel-menu-item">设置</div></router-link> -->
                <div class="sidePanel-menu-item smooth-trans" @click='logout'>退出</div>
            </div>
        </div>
    </div>
</template>

<style>
    .modal {
        display: none; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 2; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0,0,0); /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    }
    
    /* Modal Box */
    .modal-content {
        background-color: #fefefe;
        height:100%;
        width: 80%; /* Could be more or less, depending on screen size */
        max-width: 360px;
        animation-name: reveal-sidebar;
        animation-duration: 0.4s;
        display: flex;
        flex-direction: column;
        box-shadow: 0 0 0 ,0 12px 12px rgba(0, 0, 0, 0.4);
        position: fixed; /* Stay in place */
        left: 0;
        top: 0;
    }

    .modal-content .sidePanel-header {
        order:1;
        display: flex;
        flex-direction: column;
        margin-left: 12px;
        margin-right: 12px;
        margin-bottom:6px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    }
    .modal-content .sidePanel-header .sidePanel-header-icon {
        order:1;
        margin-top: 12px;
        margin-bottom: 12px;
        height:100px;
        width:100px;
        border-radius: 50%;
        background-color: #8bc34a;
        overflow: hidden;
    }

    .modal-content .sidePanel-header .sidePanel-header-icon img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }

    .modal-content .sidePanel-header .sidePanel-header-username {
        order:2;
        margin-bottom: 12px;
        margin-left: 6px;
        max-width: 100%;
        font-size: 24px;
        overflow: hidden;
    }

    .modal-content .sidePanel-menu {
        order:2;
        margin-left: 12px;
        margin-right: 12px;
        display: flex;
        flex-direction: column;
    }
    
    .modal-content .sidePanel-menu .sidePanel-menu-item {
        line-height: 32px;
        font-size: 30px;
        padding-left: 12px;
        padding-right: 12px;
        padding-top: 12px;
        padding-bottom: 12px;
        margin-bottom:6px; 
        background-color: rgba(139, 195, 75, 0.9) ;/* rgb(48, 108, 181,0.4); */
        border-radius: 4px;
        color:white;
    }

    .sidePanel-menu-item:hover {
        background-color: rgba(139, 195, 75, 0.6) !important; /* rgb(48, 108, 181,0.6) */
    }

    /* Add Animation */
    @keyframes reveal-sidebar {
        from {left: -300px; opacity: 1}
        to {left: 0; opacity: 1}
    }
</style>

<script>
export default {
    name: 'sideBar',
    props:['url'],
    methods: {
        closeSideBar: function (event) {
            let modal = document.getElementById('modal');
            if (event.target == modal) {
                // modal.style.display = "none";
                this.$store.state.sideBarOpen=false;
            }
        },
        logout:function(){
            this.$store.commit('logout');
            this.$socket.disconnect();
            this.$socket.connect();
            this.$router.push({path:`/Login`,replace:true});
        }
    },
    computed:{
        selfUrl(){
            return '/profile/'+this.$store.state.UID
        },
        status(){
            if(this.$store.state.sideBarOpen===false){
                return 'none'
            }else if(this.$store.state.sideBarOpen===true){
                return 'block'
            }
        }
    }
}
</script>
